var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "login-bg-main-section width-full float-l",
      attrs: { id: "login-main-hr" }
    },
    [
      _vm.currentEnvironment
        ? _c(
            "div",
            { staticClass: "notification-block notification-block-top" },
            [_vm._m(0)]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "login-left-section float-l" },
        [
          _c("router-link", { attrs: { to: { path: "/" } } }, [
            _c("img", {
              attrs: {
                src: "/static/images/vvg-home-logo.png",
                alt: "Velocity Truck Center"
              }
            })
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "login-right-main-section width-full float-l" },
        [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "login-form-right-section" }, [
            _c("div", { staticClass: "login-form float-l width-full" }, [
              _c(
                "form",
                { attrs: { id: "loginUserForm" } },
                [
                  _vm.ssoLogin
                    ? [
                        _c(
                          "label",
                          {
                            staticClass:
                              "checkbox-inline checkbox-bootstrap checkbox-lg"
                          },
                          [
                            _vm._v(
                              "\n                                Logout from ("
                            ),
                            _c("a", { attrs: { href: _vm.ssoUrl } }, [
                              _vm._v(_vm._s(_vm.ssoUrl))
                            ]),
                            _vm._v(
                              "),If You are not able to login please clear Cookies and login again.\n                                Please contact admin if you are still not able to Login.\n                            "
                            )
                          ]
                        )
                      ]
                    : [
                        _vm.isEmail == "undefined"
                          ? _c("label", { attrs: { for: "uname" } }, [
                              _vm._v("Dayforce Id / Email")
                            ])
                          : _vm.isEmail == true
                          ? _c("label", { attrs: { for: "uname" } }, [
                              _vm._v("Email")
                            ])
                          : _c("label", { attrs: { for: "uname" } }, [
                              _vm._v("Dayforce Id")
                            ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.loginFormData.username,
                              expression: "loginFormData.username"
                            }
                          ],
                          attrs: {
                            id: "username",
                            type: "text",
                            placeholder: "",
                            name: "uname",
                            required: ""
                          },
                          domProps: { value: _vm.loginFormData.username },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.loginFormData,
                                "username",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("font", {
                          staticClass: "text-danger",
                          domProps: {
                            innerHTML: _vm._s(_vm.frontendErrors.username)
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          { staticClass: "loginLabel", attrs: { for: "psw" } },
                          [_vm._v("Password")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.loginFormData.password,
                              expression: "loginFormData.password"
                            }
                          ],
                          attrs: {
                            id: "password",
                            type: "password",
                            placeholder: "",
                            name: "psw",
                            required: ""
                          },
                          domProps: { value: _vm.loginFormData.password },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.loginFormData,
                                "password",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("font", {
                          staticClass: "text-danger",
                          domProps: {
                            innerHTML: _vm._s(_vm.frontendErrors.password)
                          }
                        }),
                        _vm._v(" "),
                        _c("font", { staticClass: "text-danger" }, [
                          _c("label", {
                            staticClass: "error text-danger",
                            attrs: { id: "errorMsg" },
                            model: {
                              value: _vm.error,
                              callback: function($$v) {
                                _vm.error = $$v
                              },
                              expression: "error"
                            }
                          }),
                          _c("br")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "btm-login-section col-12" }, [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "btn-login-main float-l" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "hvr-sweep-to-right-red",
                                    attrs: { type: "submit", id: "loginBtn" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.attemptLogin()
                                      }
                                    }
                                  },
                                  [_vm._v("Login")]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "btn-login-main registre-btn float-l"
                              },
                              [
                                _c(
                                  "router-link",
                                  { attrs: { to: { path: "/register" } } },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "hvr-sweep-to-right-red",
                                        attrs: { type: "button" }
                                      },
                                      [_vm._v(" Not Registered? Sign up")]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "forget-text float-l col-12 float-r" },
                          [
                            _c(
                              "div",
                              { staticClass: "row" },
                              [
                                _c(
                                  "router-link",
                                  { attrs: { to: { name: "ForgotPassword" } } },
                                  [_vm._v(" Forgot password?")]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ]
                ],
                2
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "alert alert-primary alert-dismissible",
        attrs: { role: "alert", "aria-live": "polite", "aria-atomic": "true" }
      },
      [
        _c("div", { staticClass: "scroll-left" }, [
          _c("p", [_vm._v("This is Test Environment !")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "login-r-left-section" }, [
      _c("img", {
        attrs: {
          src: "/static/images/login-welcome-img.png",
          alt: "Login Welcome Img"
        }
      }),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass:
            "color-white heading-text-24 line-height-28 font-text-semi-medium-mont center mt-15 float-l"
        },
        [_vm._v(" Welcome to HR ")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ef68022e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef68022e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = null
// module chunks = 